/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import { getOGimage, getUrl } from "../../utils/getUrl";
import Head from "next/head";
import Image from "next/image";
import {
  Configure,
  InstantSearch,
  // getServerState,
  InstantSearchSSRProvider,
  useHits,
  usePagination,
} from "react-instantsearch-hooks-web";
import { history } from "instantsearch.js/es/lib/routers";
// import {InstantSearch} from 'react-instantsearch-core'
import { getServerState } from "react-instantsearch-hooks-server";
import { renderToString } from "react-dom/server";
import algoliasearch from "algoliasearch/lite";
import Link from "next/link";
import { useRouter } from "next/router";

const algoliaClient = algoliasearch(
  process.env.NEXT_PUBLIC_SEARCH_APP_ID,
  process.env.NEXT_PUBLIC_SEARCH_API_KEY
);

const searchClient = {
  ...algoliaClient,
  search(requests) {
    // console.log(requests);
    if (requests.every(({ params }) => params.query)) {
      // console.log(requests);
      //   return Promise.resolve({
      //     results: requests.map(() => ({
      //       towns: [],
      //       nbtowns: 0,
      //       nbPages: 0,
      //       page: 0,
      //       processingTimeMS: 0,
      //       townsPerPage: 0,
      //       exhaustiveNbtowns: false,
      //       query: "",
      //       params: "",
      //     })),
      //   });
    }
    return algoliaClient.search(requests);
  },
};

const CustomPaginationT = ({ currentPage, setCurrentPage }) => {
  const { currentRefinement, nbPages, refine } = usePagination();

  return (
    <div>
      {new Array(nbPages).fill(null).map((_, index) => (
        <button
          key={index}
          onClick={() => {
            refine(index);
            setCurrentPage(index);
          }}
        >
          {index + 1}
        </button>
      ))}
    </div>
  );
};

function CustomPagination() {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
  } = usePagination();
  const firstPageIndex = 0;
  const previousPageIndex = currentRefinement - 1;
  const nextPageIndex = currentRefinement + 1;
  const lastPageIndex = nbPages - 1;

  return (
    <ul className=" flex flex-row space-x-3 ">
      {/* <PaginationItem
        isDisabled={isFirstPage}
        href={createURL(firstPageIndex)}
        onClick={() => {refine(firstPageIndex)
          // setCurrentPage(firstPageIndex);
        }}
      >
        First
      </PaginationItem> */}
      {/* <PaginationItem
        isDisabled={isFirstPage}
        href={createURL(previousPageIndex)}
        onClick={() => {refine(previousPageIndex)
          
        }}
      >
        Previous
      </PaginationItem> */}
      {pages.map((page) => {
        const label = page + 1;

        return (
          <PaginationItem
            key={page}
            isDisabled={false}
            aria-label={`Page ${label}`}
            href={createURL(page)}
            onClick={() => {
              refine(page);
              // setCurrentPage(page);
            }}
          >
            {label}
          </PaginationItem>
        );
      })}
      {/* <PaginationItem
        isDisabled={isLastPage}
        href={createURL(nextPageIndex)}
        onClick={() => {refine(nextPageIndex)
          // setCurrentPage(nextPageIndex);
        }}
      >
        Next
      </PaginationItem> */}
      {/* <PaginationItem
        isDisabled={isLastPage}
        href={createURL(lastPageIndex)}
        onClick={() => {refine(lastPageIndex)
          // setCurrentPage(lastPageIndex);
        }}
      >
        Last
      </PaginationItem> */}
    </ul>
  );
}

function PaginationItem({ isDisabled, href, onClick, ...props }) {
  if (isDisabled) {
    return (
      <li>
        <span {...props} />
      </li>
    );
  }

  return (
    <li className="  w-4">
      <a
        href={href}
        rel="noindex"
        className={" " + (isDisabled ? "" : " ")}
        onClick={(event) => {
          if (isModifierClick(event)) {
            return;
          }

          event.preventDefault();

          onClick(event);
        }}
        {...props}
      />
    </li>
  );
}

function isModifierClick(event) {
  const isMiddleClick = event.button === 1;

  return Boolean(
    isMiddleClick ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey
  );
}

function TownHitImage({ props }) {
  const { hits, results, sendEvent } = useHits();
  const towns = [];
  return (
    <div className="grid grid-cols-1 gap-y-6 md:grid-cols-2 md:gap-x-6 lg:grid-cols-3 lg:gap-x-10 lg:gap-y-10">
      {hits?.map((hit) => {
        if (!towns.includes(hit.propertyTown.townSlug)) {
          const ogURL = `${getUrl()}/api/og/town-main-og?name=${
            hit?.propertyTown.townName
          }&county=${hit?.propertyCounty?.countyName}`;
          towns.push(hit?.propertyTown?.townSlug);
          return (
            <Link
              href={{
                pathname: `/town/${hit?.propertyTown?.townSlug}`,
              }}
              key={hit.objectID}
              as={`/town/${hit?.propertyTown?.townSlug}`}
              passHref
            >
              <a key={hit.objectID} className=" flex flex-col space-y-2">
                <div className="relative flex h-40 cursor-pointer flex-col rounded-md  bg-zote-background-light lg:h-40">
                  <Image
                    alt={`Apartments and Houses for Rent in ${hit?.propertyTown.townName} - Zote`}
                    src={ogURL}
                    title={`Apartments and Houses for Rent in ${hit?.propertyTown.townName} - Zote`}
                    unoptimized
                    layout="fill"
                    className=" h-[90%] rounded-md object-contain object-left transition duration-300 hover:scale-105"
                  />
                </div>
                <h2 className=" cursor-pointer font-semibold text-zote-secondary  lg:text-lg">{`Apartments and Houses for Rent in ${hit?.propertyTown.townName}`}</h2>
              </a>
            </Link>
          );
        }
      })}
    </div>
  );
}

function Index({ serverState }) {
  //  console.log(serverUrl)
  const serverUrl = getUrl() + `/town`;

  const router = useRouter();

  const [currentPage, setCurrentPage] = useState(0);

  //console.log(serverState);
  const props =
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? serverState?.initialResults?.properties?.results[0]?.hits
      : serverState?.initialResults?.staging_PROPERTIES?.results[0]?.hits;
  // console.log(props);

  const breadSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@type": "Webpage",
          "@id": `${getUrl()}`,
          name: "Zote",
          url: `${getUrl()}`,
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "WebPage",
          "@id": `${getUrl()}/town`,
          name: "Find close and available apartments in your town in Kenya - Zote",
          url: `${getUrl()}/town`,
        },
      },
    ],
  };
  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <title>{`Find close and available apartments in your town in Kenya - Zote`}</title>
        <meta
          name="description"
          content={`Explore apartments, studios, villas and more options in your town to suit your needs | Zote`}
        />
        <meta
          name="og:title"
          content={`Explore apartments, studios, villas and more options in your town to suit your needs | Zote`}
        />

        <meta
          property="og:description"
          content={`Find apartments, studios, villas and more in your town. 
          Search through the largest catalogue of rentals and houses
          | Zote`}
        />

        <meta property="og:url" content={`${getUrl()}/town`} />
        <meta name="og:image" content={`${getOGimage()}`} />
        <link rel="canonical" href={`${getUrl()}/town`} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadSchema) }}
        />
      </Head>

      <main className="flex flex-col space-y-3 px-5 py-8 lg:px-32 lg:py-16">
        <InstantSearchSSRProvider {...serverState}>
          <InstantSearch
            key={"town-index"}
            searchClient={searchClient}
            indexName={process.env.NEXT_PUBLIC_PROPERTIES_INDEX}
            routing={{
              router: history({
                getLocation: () =>
                  typeof window === "undefined"
                    ? new URL(serverUrl)
                    : window.location,
              }),
            }}
          >
            <>
              <Configure
                hitsPerPage={4}
                maxValuesPerFacet={100}
                page={currentPage}
              />
              <h1 className=" mb-3 text-xl font-semibold lg:text-2xl lg:font-semibold">
                Find close and available apartments in your town
              </h1>
              <TownHitImage props={props} />
              <div className=" ">
                <CustomPagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </>
          </InstantSearch>
        </InstantSearchSSRProvider>
      </main>
    </>
  );
}

export async function getStaticProps({ params }) {
  const serverUrl = getUrl() + `/town`;

  const serverState = await getServerState(<Index serverUrl={serverUrl} />, {
    renderToString,
  });

  let props =
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? serverState?.initialResults?.properties?.results[0]?.hits
      : serverState?.initialResults?.staging_PROPERTIES?.results[0]?.hits;

  // Reduce the objects in the props array
  props = props.map((item) => ({
    propertyTown: item.propertyTown,
    objectID: item.objectID,
    propertyCounty: item.propertyCounty,
  }));

  if (process.env.NEXT_PUBLIC_VERCEL_ENV === "production") {
    serverState.initialResults.properties.results[0].hits = props;
  } else {
    serverState.initialResults.staging_PROPERTIES.results[0].hits = props;
  }

  return {
    props: {
      serverState,
      serverUrl,
    },
    revalidate: 10080,
  };
}

export default Index;
